import { useTheme as useThemeBase } from 'styled-components';
export var useTheme = function () {
    var themeContext = useThemeBase();
    return themeContext;
};
export default useTheme;
//# sourceMappingURL=index.js.map